<template>
  <div>
    <div class="checkout">
      <div class="container">
        <div class="row pb-4">
          <div class="col-lg-12">
            <h2 class="checkout-title text-center" style="font-size: 3rem">
              CREA UN NUOVO CASO CLINICO
            </h2>
            <LoadedComponent :loading="loading" :percentual="percentual" :message="messageProgress" />

            <form class="pt-2 pr-4 pl-4" id="form-date-submit" @submit.prevent="create_clinical_case"
              v-if="loading == false">
              <div class="card pb-4 bg-light">
                <div class="card-header text-dark">DATI DEL CASO</div>
                <div class="card-body">
                  <div class="row">
                    <div v-if="Object.keys(errors).length > 0" class="col-md-12">
                      <div class="alert alert-danger mt-1 mb-1">
                        <ul>
                          <li v-for="(errorMessages, field) in errors" :key="field">
                            <ul>
                              <li v-for="(message, index) in errorMessages" :key="index">
                                {{ message }}
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="col-sm-12">
                      <label for="nome_caso">Nome del caso *</label>
                      <input type="text" class="form-control" name="nome" id="nome_caso"
                        placeholder="Aggiorna il nome del caso" v-model="formClinicalCase.name" required />

                      <div class="alert alert-danger" v-if="errors.name">
                        {{ errors.name[0] }}
                      </div>
                    </div>
                    <!-- End .col-sm-6 -->
                    <div class="col-sm-6">
                      <label for="nome_caso">Data pubblicazione *</label>
                      <input type="date" class="form-control" name="data_pubblicazione" id="data_pubblicazione_edit"
                        v-model="formClinicalCase.publish_date" :min="new Date().toJSON().slice(0, 10)" required />
                      <div class="alert alert-danger" v-if="errors.publish_date">
                        {{ errors.publish_date[0] }}
                      </div>
                    </div>

                    <div class="col-sm-6">
                      <label for="company_edit" class="form-label">Azienda sponsor del caso
                      </label>
                      <select class="form-control" id="company_edit" name="company_id"
                        v-model="formClinicalCase.company_id" required>
                        <option :value="null" selected>Nessuno sponsor</option>
                        <option v-for="company in companies" :key="company.id" :value="company.id">
                          {{ company.name }}
                        </option>
                      </select>

                      <div class="alert alert-danger" v-if="errors.company_id">
                        {{ errors.company_id[0] }}
                      </div>
                    </div>

                    <div class="col-sm-12">
                      <label for="categorie_mediche_edit" class="form-label">Tipologia Caso *</label>
                      <select class="form-control" id="categorie_mediche_edit" name="id_categoria_medica"
                        v-model="formClinicalCase.category_medical_id" readonly>
                        <option :value="null" selected>
                          Seleziona la categoria appropriata
                        </option>
                        <option v-for="category in categoryMedical" :key="category.id" :value="category.id">
                          {{ category.name }}
                        </option>
                      </select>
                      <div class="alert alert-danger" v-if="errors.category_medical_id">
                        {{ errors.category_medical_id[0] }}
                      </div>
                    </div>

                    <div class="col-sm-12">
                      <label for="distretto_anatomico" class="form-label">Distretto Anatomico *</label>

                      <select class="form-control" id="distretto_anatomico" name="id_distretto"
                        v-model="formClinicalCase.anatomical_district_id" required>
                        <option :value="null" selected>
                          Seleziona un distretto anatomico
                        </option>
                        <option v-for="anatomical in anatomicalDistrict" :key="anatomical.id" :value="anatomical.id">
                          {{ anatomical.name }}
                        </option>
                      </select>

                      <div class="alert alert-danger" v-if="errors.anatomical_district_id">
                        {{ errors.anatomical_district_id[0] }}
                      </div>
                    </div>

                    <div class="col-sm-12">
                      <h5 class="card-title text-center mb-1">Trattamenti</h5>
                      <p class="mb-2 text-center">Seleziona i trattamenti</p>
                      <div class="row">
                        <div v-for="patology in patologies" :key="patology.id" class="col-md-2">
                          <!-- Categoria con icona per aprire/chiudere -->
                          <div class="mb-1">
                            <input type="checkbox" v-model="formClinicalCase.patologies" :value="patology.id" />
                            {{ patology.name }}
                          </div>
                        </div>
                      </div>
                      <div class="alert alert-danger" v-if="errors.patologies">
                        {{ errors.patologies[0] }}
                      </div>
                    </div>

                    <div class="col-md-12">
                      <label for="descrizione">Descrizione del caso clinico *</label>
                      <textarea class="form-control" id="descrizione" rows="3" name="descrizione"
                        placeholder="Scrivi la descrizione del caso clinico che stai per pubblicare"
                        v-model="formClinicalCase.description"></textarea>

                      <div class="alert alert-danger" v-if="errors.description">
                        {{ errors.description[0] }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card mb-4 mt-2">
                <div class="card-header">Allegati del caso</div>
                <div class="card-body">
                  <div class="input-group mb-3">
                    <div class="custom-file">
                      <input type="file" class="custom-file-input" name="files[]" ref="fileInput"
                        @change="handleFileUpload" id="fileInput" aria-describedby="inputGroupFileAddon01" multiple />
                    </div>
                    <label class="custom-file-label text-center labels-files" for="fileInput" id="labelsfiles">{{
                      nameAttachmentsFiles }}
                    </label>
                  </div>
                </div>
              </div>

              <div class="card mb-4">
                <div class="card-header">Copertina del caso</div>

                <div class="card-body">
                  <div class="input-group mb-3">
                    <div class="custom-file">
                      <input type="file" class="custom-file-input" name="files" ref="fileInput"
                        @change="handleFileUploadCover" id="fileInput" aria-describedby="inputGroupFileAddon01"
                        accept="image/png, image/jpeg,image/jpg" />
                    </div>
                    <label class="custom-file-label text-center labels-files" for="fileInput" id="labelsfiles">{{
                      nameCoverFiles }}
                    </label>
                  </div>
                </div>
              </div>

              <div class="card mb-4">
                <div class="card-header">OPZIONI DEL CASO</div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-12 text-center">
                      <h6>Accesso</h6>
                      <div class="form-check form-check-inline mr-4">
                        <input class="form-check-input" type="radio" name="accessible" id="checkbox_accessible_to_all"
                          value="1" v-model="formClinicalCase.options.all_notify" @change="checkBoxAccessible" />
                        <label class="form-check-label" for="checkbox_accessible_to_all">Rendi il caso accessibile a
                          tutti</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="accessible" id="checkbox_accessible_limit"
                          v-model="formClinicalCase.options.all_notify" value="0" @change="checkBoxAccessible" />
                        <label class="form-check-label" for="checkbox_accessible_limit">Limita l'accesso al caso
                          selezionando gli
                          utenti</label>
                      </div>
                    </div>
                    <div class="col-md-12 text-center mt-2">
                      <h6>Anonimato del caso</h6>
                      <div class="form-check form-check-inline mr-4">
                        <input class="form-check-input" type="radio" name="anonymouse" id="anonymouse"
                          v-model="formClinicalCase.options.anonymous" value="1" />
                        <label class="form-check-label" for="anonymouse">Rendi il caso anonimo (Non verrà mostrato il
                          tuo
                          nome)</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="anonymouse" id="anonymouse_public" value="0"
                          v-model="formClinicalCase.options.anonymous" />
                        <label class="form-check-label" for="anonymouse_public">Mostra il tuo nome</label>
                      </div>
                    </div>

                    <div class="col-md-12 text-center mt-2">
                      <h6>Metodo di notifica</h6>
                      <div class="form-check form-check-inline mr-4">
                        <input class="form-check-input" type="radio" name="checkbox_type_notify" id="email_notify"
                          v-model="formClinicalCase.options.checkbox_type_notify
                            " value="1" />
                        <label class="form-check-label" for="email_notify">Notifica via email</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="checkbox_type_notify" id="sms_notify"
                          value="0" v-model="formClinicalCase.options.checkbox_type_notify
                            " />
                        <label class="form-check-label" for="sms_notify">Notifica via sms</label>
                      </div>
                    </div>

                    <div class="col-md-12 text-center mt-2">
                      <h6>Personalizza la tua notifica</h6>
                      <div class="form-check form-check-inline mr-4">
                        <input class="form-check-input" type="radio" name="custom_notify" id="custom_notify" v-model="formClinicalCase.options.checkbox_custom_notify
                          " value="1" />
                        <label class="form-check-label" for="custom_notify">Personalizza la notifica</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="custom_notify" id="notify_default" value="0"
                          v-model="formClinicalCase.options.checkbox_custom_notify
                            " />
                        <label class="form-check-label" for="notify_default">Invia la notifica di default</label>
                      </div>
                    </div>

                    <div class="col-md-12" v-if="
                      formClinicalCase.options.checkbox_custom_notify == 1
                    ">
                      <label for="custom_message">Personalizza la tua notifica</label>
                      <textarea class="form-control" id="custom_message" rows="3" name="descrizione"
                        placeholder="Testo del messaggio che verrà inserito nella mail di notifica"
                        v-model="formClinicalCase.options.custom_notify_message"></textarea>
                    </div>

                    <div class="alert alert-danger" v-if="errors.custom_message">
                      {{ errors.custom_message[0] }}
                    </div>

                    <div class="col-md-12 text-center mt-2">
                      <h6>Pubblicazione caso</h6>
                      <div class="form-check form-check-inline mr-4">
                        <input class="form-check-input" type="radio" name="draft" id="draft_false"
                          v-model="formClinicalCase.draft" :value="false" />
                        <label class="form-check-label" for="draft_false">Pubblica caso a tutti</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="draft" id="draft_true" :value="true"
                          v-model="formClinicalCase.draft" />
                        <label class="form-check-label" for="draft_true">Salva il caso in bozze</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row flex-column pb-2 pl-2 pr-2">
                <div class="flex-row">
                  <button type="submit" class="btn btn-primary float-right">
                    Pubblica il caso clinico <i class="las la-save"></i>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true"
    id="users-group">
    <div class="modal-dialog modal-xl" role="document" style="max-width: 90%">
      <div class="modal-content">
        <div class="modal-header">
          <div class="w-100">
            <h5 class="modal-title text-center">
              Seleziona gli utenti o i gruppi
            </h5>
          </div>

          <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="close-modal-delete-news">
            <span aria-hidden="true"><i class="icon-close"></i></span>
          </button>
        </div>
        <div class="modal-body p-4">
          <div class="w-100 text-center">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="checkbox_group" id="users_group_checkbox"
                v-model="checkbox_group" value="0" @change="toggleSelectUserGroup" />
              <label class="form-check-label" for="users_group_checkbox">Seleziona un gruppo di utenti</label>
            </div>

            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="checkbox_group" id="all_users_checkbox"
                v-model="checkbox_group" value="1" @change="toggleSelectUserGroup" />
              <label class="form-check-label" for="all_users_checkbox">Seleziona gli utenti singolarmente</label>
            </div>

            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="checkbox_group" id="new_groups"
                v-model="checkbox_group" value="2" @change="toggleSelectUserGroup" />
              <label class="form-check-label" for="new_groups">Crea un nuovo gruppo</label>
            </div>
          </div>

          <div class="row" v-if="checkbox_group == 0">
            <div class="col-md-3" v-for="(group, index) in groups" :key="group.id">
              <ul>
                <li>
                  <div class="icheck-wetasphalt mt-3">
                    <input type="checkbox" :id="'checkbox-group-' + group.id"
                      v-model="formClinicalCase.options.groupsSelected" :value="index" />
                    <label :for="'checkbox-group-' + group.id">{{ group.name }} (Numero utenti:
                      {{ group.numbers_users }})
                    </label>
                  </div>
                </li>
              </ul>
              <div class="dropdown">
                <button class="btn btn-secondary dropdown-toggle" type="button"
                  :id="'dropdownMenuButton-group-' + group.id" data-toggle="dropdown" aria-haspopup="true"
                  aria-expanded="false">
                  Guarda gli utenti del gruppo
                </button>
                <div class="dropdown-menu" :aria-labelledby="'dropdownMenuButton-group-' + group.id">
                  <span class="dropdown-item" v-for="user in group.users" :key="user.id">
                    {{ user.name }} {{ user.lastname }}
                  </span>
                </div>
              </div>
            </div>
            <div class="w-100 text-right">
              <button type="button" class="btn btn-primary" @click="confirm_group_users">
                Conferma
              </button>
            </div>
          </div>

          <div v-if="checkbox_group == 2">
            <form class="needs-validation" @submit.prevent="create_group">
              <div class="col-md-12 mb-3">
                <label for="name_group">Nome del gruppo</label>
                <input type="text" class="form-control" id="name_group" placeholder="Scrivi il nome del gruppo"
                  v-model="formGroups.name" />
                <div class="bg-info text-danger p-2" v-if="errors_group.name">
                  {{ errors_group.name[0] }}
                </div>
              </div>

              <div class="col-md-12">
                <h6 class="text-center">Seleziona gli utenti</h6>
                <div class="bg-info text-danger p-2" v-if="errors_group.users">
                  {{ errors_group.users[0] }}
                </div>
                <div class="row">
                  <div class="col-md-3" v-for="user in users" :key="user.id">
                    <ul>
                      <li>
                        <div class="icheck-wetasphalt mt-3">
                          <input type="checkbox" :id="'chb1-' + user.id" v-model="formGroups.users" :value="user.id" />
                          <label :for="'chb1-' + user.id">{{
                            user.full_name
                            }}</label>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="w-100 text-right">
                <button type="submit" class="btn btn-primary">
                  Salva il gruppo
                </button>
              </div>
            </form>
          </div>

          <div v-if="checkbox_group == 1">
            <div class="row">
              <div class="col-md-3" v-for="user in users" :key="user.id">
                <ul>
                  <li>
                    <div class="icheck-wetasphalt mt-3">
                      <input type="checkbox" :id="'checkbox-' + user.id" v-model="this.formClinicalCase.options.users"
                        :value="user.id" />
                      <label :for="'checkbox-' + user.id">{{
                        user.full_name
                        }}</label>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="w-100 text-right">
              <button type="button" class="btn btn-primary" @click="custom_users_notification">
                Conferma
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import httpauth from "@/services/httpauth.js";
import LoadedComponent from "@/components/LoadedComponent.vue";
import httpservices from "@/services/httpservices.js";

import router from "@/router";
import $ from "jquery";
import { useAuth } from "@/stores/auth.js";
import { useToast } from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
window.jQuery = $;
window.$ = $;
export default {
  name: "CreateClinicalCase",

  components: {
    LoadedComponent,
  },
  props: {},
  data() {
    return {
      patologies: [],
      categoryMedical: [],
      anatomicalDistrict: [],
      checkbox_accessible: 1,
      checkbox_group: 0,
      errors: [],
      coverAttachment: null,
      users: [],
      messageProgress: "",
      errorMessage: "",

      slug: "",
      clinicalCaseId: 0,
      userCompany: false,
      companies: [],
      groups: [],
      loading: false,
      nameAttachmentsFiles: "Scegli i file (MAX 1 GIGA)",
      nameCoverFiles:
        "Scegli un immagine da usare come copertina del caso (Max 1 GIGA)",
      formGroups: {
        name: "",
        description: "",
        users: [],
      },
      selectedFiles: [],
      cover: null,
      errors_group: {},
      percentual: 0,
      formClinicalCase: {
        name: "",
        publish_date: new Date().toJSON().slice(0, 10),
        category_medical_id: null,
        anatomical_district_id: null,
        description: "",
        company_id: null,
        draft: true,
        subpatologies: [],
        patologies: [],

        options: {
          users: [],
          groupsSelected: [],
          all_notify: 1,
          type: "allusers",
          anonymous: 0,
          checkbox_custom_notify: 0,
          custom_notify_message: "",
          checkbox_type_notify: 1,
        },
      },
    };
  },
  mounted() {
    this.loading = true;
    this.fetchCategoryMedical();
    this.fetchPatology();
    this.fetchAtomicalDistrict();
    this.fetchUsers();
    this.fetchGroups();
  },
  created() {
    this.loadCompanies();
  },
  methods: {
    confirm_group_users() {
      if (this.groups.length == 0)
      {
        const $toast = useToast();
        $toast.open({
          message: "Non hai selezionato nemmeno un gruppo di utenti",
          type: "success",
          position: "top-right",
        });
        return;
      }
      for (
        var i = 0;
        i < this.formClinicalCase.options.groupsSelected.length;
        i++
      )
      {
        for (
          var j = 0;
          j <
          this.groups[this.formClinicalCase.options.groupsSelected[i]].users
            .length;
          j++
        )
        {
          if (
            this.formClinicalCase.options.users.includes(
              this.groups[this.formClinicalCase.options.groupsSelected[i]]
                .users[j].id
            ) == false
          )
          {
            this.formClinicalCase.options.users.push(
              this.groups[this.formClinicalCase.options.groupsSelected[i]]
                .users[j].id
            );
          }
        }
      }
      $("#users-group").modal("hide");
    },

    custom_users_notification() {
      $("#users-group").modal("hide");
      this.formClinicalCase.options.type = "custom";
    },
    toggleSelectUserGroup() {
      switch (parseInt(this.checkbox_group))
      {
        //Seleziono un gruppo di utenti
        case 0:
          this.formClinicalCase.options.users = [];
          this.formClinicalCase.options.type = "group";
          break;
        //Seleziono utenti singolarmente
        case 1:
          this.formClinicalCase.options.users = [];
          this.formClinicalCase.options.type = "custom";
          break;
        case 2:
          this.formClinicalCase.options.users = [];
          this.formClinicalCase.options.type = "";
      }
    },
    async create_group() {
      await httpauth
        .post("/groups", this.formGroups)
        .then((response) => {
          if (response.data.status)
          {
            this.fetchGroups();
            const $toast = useToast();
            $toast.open({
              message: response.data.message,
              type: "success",
              position: "top-right",
            });
            this.checkbox_group = 0;
          }
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          } else if (error.response.data.errors)
          {
            this.errors_group = error.response.data.errors;
            console.log(this.errors_group);
          }
        });
    },
    checkBoxAccessible() {
      if (this.formClinicalCase.options.all_notify == 0)
      {
        $("#users-group").modal("show");
        this.formClinicalCase.options.type = "group";
      }
    },
    async fetchGroups() {
      await httpauth
        .get("/groups")
        .then((response) => {
          this.groups = response.data.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async upload_attachments() {
      this.loading = true;
      this.messageProgress = "Sto caricando gli allegati";
      this.percentual = 0;
      await httpservices
        .uploadAttachments(
          this.selectedFiles,
          this.clinicalCaseId,
          "activity",
          0,
          (percentCompleted) => {
            this.percentual = percentCompleted;
            // Puoi fare qualcosa con il valore percentCompleted qui
          }
        )
        .then((response) => {
          this.loading = false;
          if (response.data.status == true)
          {
            if (this.cover != null)
            {
              this.uploadCover(this.clinicalCaseId);
              return;
            }
            this.loading = false;
            router.push("/casi-clinici");
            return;
          }
          this.loading = false;
          localStorage.removeItem("messageSuccessClinicalCase");
          localStorage.setItem(
            "messageErrorClinicalCase",
            response.data.message
          );
          router.push("/casi-clinici");
        })
        .catch(() => {
          this.loading = false;
          localStorage.setItem(
            "messageErrorClinicalCase",
            "Il caso è stato pubblicanto mentre gli allegati no. Vai nella sezione modifica e controlla"
          );
          router.push("/casi-clinici");
        });
    },
    handleFileUpload(event) {
      const maxSize = 1 * 1024 * 1024 * 1024;
      const files = Array.from(event.target.files);
      const totalSize = files.reduce(
        (accumulator, file) => accumulator + file.size,
        0
      );
      const validFiles = [];
      if (totalSize <= maxSize)
      {
        const allowedTypes = [
          "application/pdf",
          "application/msword",
          "application/vnd.ms-office",
          "video/mp4",
          "image/jpeg",
          "image/png",
          "image/jpg",
          "application/dicom",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ];
        var message = false;
        Array.from(files).forEach((file) => {
          // Esegui l'azione desiderata su ogni file
          if (
            !allowedTypes.includes(file.type) &&
            httpservices.checkDicom(file) == false
          )
          {
            message = true;
            return;
          }
          validFiles.push(file.name);
        });
        if (message == true)
        {
          alert(
            "Per favore seleziona un file valido (PDF/DOC/DOCX/JPEG/JPG/PNG/MP4/DCM)."
          );
        }

        this.selectedFiles = files;
        this.nameAttachmentsFiles = validFiles.join(", ");
      } else
      {
        alert("La dimensione totale dei file supera 1 GB");
      }
    },
    async fetchCategoryMedical() {
      await httpservices
        .getCategoryMedical()
        .then((response) => {
          this.categoryMedical = response.data.data;
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
    async loadCompanies() {
      await httpservices
        .getCompany()
        .then((response) => {
          this.companies = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async fetchPatology() {
      await httpservices
        .getPatology()
        .then((response) => {
          this.patologies = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async fetchAtomicalDistrict() {
      await httpservices
        .getAnatomicalDistrict()
        .then((response) => {
          this.anatomicalDistrict = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async fetchUsers() {
      await httpservices
        .getUsers()
        .then((response) => {
          this.users = this.users = response.data.data;
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },

    async create_clinical_case() {
      this.percentual = 0;
      this.messageProgress = "";
      this.loading = true;
      if (this.formClinicalCase.options.all_notify == 0)
      {
        if (this.checkbox_group == 2)
        {
          const $toast = useToast();
          this.loading = false;
          $toast.open({
            message:
              "Seleziona i gruppi o gli utenti a cui è permesso accedere",
            type: "warning",
            position: "top-right",
            // all of other options may go here
          });
          $("#users-group").modal("show");
          this.formClinicalCase.options.type = "";
        }
        if (this.formClinicalCase.options.users.length == 0)
        {
          const $toast = useToast();
          this.loading = false;
          $toast.open({
            message:
              "Seleziona i gruppi o gli utenti a cui è permesso accedere",
            type: "warning",
            position: "top-right",
            // all of other options may go here
          });
          $("#users-group").modal("show");
          this.formClinicalCase.options.type = "";
        }
      }
      if (this.selectedFiles.length == 0)
      {
        const $toast = useToast();
        this.loading = false;
        $toast.open({
          message:
            "Per creare un caso clinico è necessario inserire degli allegati!",
          type: "warning",
          position: "top-right",
          // all of other options may go here
        });
        return;
      }
      if (this.formClinicalCase.options.groupsSelected.length > 0)
      {
        const groupsSelected = this.formClinicalCase.options.groupsSelected;

        this.formClinicalCase.options.groupsSelected = [];
        for (var i = 0; i < groupsSelected.length; i++)
        {
          this.formClinicalCase.options.groupsSelected.push(
            this.groups[groupsSelected[i]].id
          );
        }
      }
      this.messageProgress = "Sto caricando il caso clinico";
      await httpauth
        .post("/casi-clinici", this.formClinicalCase)
        .then((response) => {
          if (response.data.status == true)
          {
            localStorage.setItem(
              "messageSuccessClinicalCase",
              response.data.message
            );
            this.clinicalCaseId = response.data.data.id;
            this.slug = response.data.data.slug;
            this.upload_attachments();
            return;
          }
          this.loading = false;
          const $toast = useToast();
          $toast.open({
            message: response.data.message,
            type: "warning",
            position: "top-right",
            // all of other options may go here
          });
          //this.successMessageFirstStep = response.data.message;

          this.errors = [];
        })
        .catch((error) => {
          this.loading = false;
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          } else if (error.response.data.errors)
          {
            this.errors = error.response.data.errors;
          }
        });
    },

    handleFileUploadCover(event) {
      const maxSize = 1 * 512 * 512 * 512;
      const file = event.target.files[0];
      const totalSize = file.size;
      const $toast = useToast();
      this.nameCoverFiles =
        "Scegli un immagine da usare come copertina del caso (Max 1 GIGA)";
      this.cover = null;
      if (totalSize <= maxSize)
      {
        const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
        if (allowedTypes.includes(file.type))
        {
          this.cover = file;
          this.nameCoverFiles = file.name;
        } else
        {
          $toast.open({
            message: "Devi caricare un immagine jpg, png o jpeg",
            type: "danger",
            position: "top-right",
            // all of other options may go here
          });
        }
      } else
      {
        $toast.open({
          message: "Hai caricato un immagine troppo pesante!",
          type: "danger",
          position: "top-right",
          // all of other options may go here
        });
      }
    },
    async uploadCover(model_id) {
      this.messageProgress = "Sto caricando la copertina allegati";
      const formData = new FormData();
      formData.append("model", "activity");
      formData.append("model_id", model_id);
      formData.append("cover", this.cover);
      await httpauth
        .post("/attachments/cover/store", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => {
          this.loading = false;
          router.push("/casi-clinici");
          return;
        })
        .catch((error) => {
          if (error.response.message.cover[0])
          {
            const $toast = useToast();
            $toast.open({
              message: error.response.message.cover[0],
              type: "danger",
              position: "top-right",
              // all of other options may go here
            });
          } else
          {
            this.loading = false;
            localStorage.setItem(
              "messageErrorClinicalCase",
              "Il caso è stato pubblicanto. La cover non è stata caricata vai in modifica e controlla"
            );
            router.push("/casi-clinici");
          }
        });
    },
  },
};
</script>


<style>
.labels-files {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>